import { FreeTextQueryPayload, FreeTextType } from '../../../types';

export const queryAutocompleteOverload =
  (onFreeTextQuery: (payload: FreeTextQueryPayload) => void) =>
  (text: string, action: string, type: FreeTextType): void => {
    if (action === 'input-change' || action === 'menu-close') {
      onFreeTextQuery({ type, freeText: text });
    }
  };
